<template>
	<div class="modal-tbf active modal-register">
		<transition name="slide" mode="out-in">
			<register-step-1 v-if="step_active == 1 && ($route.name == 'register' || $route.name == 'register_all')" :user="user" @next_step="next_step" />
			<register-step-12 v-if="step_active == 12 && ($route.name == 'register' || $route.name == 'register_all')" :user="user" @next_step="next_step" />
			<register-step-2 v-if="step_active == 2 && ($route.name == 'register' || $route.name == 'register_all')" :user="user" @next_step="next_step" />
			<register-step-21 v-if="step_active == 21 && ($route.name == 'register' || $route.name == 'register_all')" :user="user" @next_step="next_step" />
			<register-step-3 v-if="step_active == 3 && $route.name == 'payment'" :user="user" @next_step="next_step" />
		</transition>

		<div class="bottom-icons">
			<a href="https://stripe.com" target="_blank" style="margin: 0 auto;">
				<img src="/build/images/powered-by-stripe-white.png" style="height: 50px; width: auto;" />
			</a>
			<!-- <div class="item">
				<div class="icon"><icon-lock /></div>
				<div class="text">
					<div class="primary">Tranzacție Sigură</div>
					<div class="secondary">256BIT - Encryption</div>
				</div>
			</div>
			<div class="item">
				<div class="icon"><icon-thumbs-up /></div>
				<div class="text">
					<div class="primary">Acces Imediat</div>
					<div class="secondary">La Toate Materialele</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
import RegisterStep1 from "./RegisterStep1";
import RegisterStep12 from "./RegisterStep12";
import RegisterStep2 from "./RegisterStep2";
import RegisterStep21 from "./RegisterStep21";
import RegisterStep3 from "./RegisterStep3";
import IconLock from "../Icons/Lock";
import IconThumbsUp from "../Icons/ThumbsUp";

export default {
	data() {
		return {
			loaded: false,
			step_active: this.$route.name == "payment" ? 3 : 1,
			packages: [],
			packageActive: {},
			user: {
				first_name: "",
				last_name: "",
				email: "",
				password: "",
				country: "",
				language: "",
				phone: "",
				has_company: "",
				company_name: "",
				bank_name: "",
				company_cui: "",
				complet_name: "",
				cnp: "",
				terms_and_conditions: "",
			},
		};
	},
	components: {
		RegisterStep1,
		RegisterStep12,
		RegisterStep2,
		RegisterStep21,
		RegisterStep3,
		IconLock,
		IconThumbsUp,
	},
	watch: {},
	async mounted() {
		if (this.$route.query.token) {
			await this.checkCanRegister();
		} else {
			// alert('Aici ar trebui sa facem redirect')
			// window.location.href = 'https://www.40q.ro/'
		}
	},
	methods: {
		checkCanRegister() {
			axios.get("/can-register", { params: { package_token: this.$route.query.token, language: this.$route.query.lang ? this.$route.query.lang : "ro" } }).then(({ data }) => {
				if (data.data) {
					this.loaded = true;
				} else {
					// alert('Aici ar trebui sa facem redirect')
				}
			});
		},
		viewGame() {
			$(".bird-login").removeClass("active");
			setTimeout(() => {
				this.view_game = true;
				setTimeout(() => {
					game_start();
				}, 0);
			}, 300);
		},
		next_step(value) {
			this.user = value.user ? value.user : this.user;

			if (value.action == "finish_redirect") {
				this.$router.push("/");
			} else {
				this.step_active = value.next_step ? value.next_step : this.step_active;
			}
		},
	},
};
</script>
